export const getBaseName = (path) => {
  //  console.log('path ', path)
  if (path) {
    const parsed = path.split("/");
    return parsed[parsed.length - 1];
  }
  return "";
};
